import src from "IMAGE";
export default { src, width: 14, height: 10, blurWidth: 0, blurHeight: 0};
